import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FuseConfirmationService } from '@fuse/services/confirmation/confirmation.service';
import { FuseConfirmationDialogComponent } from '@fuse/services/confirmation/dialog/dialog.component';
import { CommonModule } from '@angular/common';
import { VrsConfirmDialogComponent } from './dialog/vrs-dialogs/vrs-confirm-dialog.component';
import { TranslocoCoreModule } from 'app/core/transloco/transloco.module';
import { VrsResponseDialogComponent } from './dialog/vrs-dialogs/vrs-response-dialog.component';


@NgModule({
    declarations: [
        FuseConfirmationDialogComponent,
        VrsConfirmDialogComponent,
        VrsResponseDialogComponent
    ],
    imports     : [
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        CommonModule,
        TranslocoCoreModule
    ],
    providers   : [
        FuseConfirmationService
    ]
})
export class FuseConfirmationModule
{
    /**
     * Constructor
     */
    constructor(private _fuseConfirmationService: FuseConfirmationService)
    {
    }
}
